// Importar imagens dos casos SOMAR
import somarCase1 from '../images/testimonial/sa-tes01.jpg'
import somarCase2 from '../images/testimonial/sa-tes02.jpg'
import somarCase3 from '../images/testimonial/sa-tes03.jpg'
import somarCase4 from '../images/testimonial/sa-tes04.jpg'


const caseStudies = [
  // Casos SOMAR Cloud - Projetos Reais
  {
    id: 1,
    category: "cat1",
    img: somarCase1,
    title: "Migração Cloud VPS - Indústria Alimentícia",
    slug: "migracao-cloud-vps-industria-alimenticia",
    description: "Migração completa da infraestrutura local para Cloud VPS, resultando em 78% de redução de custos e 99.9% de disponibilidade.",
    client: "Indústria Alimentícia Regional",
    service: "Cloud VPS + Migração",
    location: "Interior de SP, Brasil",
    result1: "78% redução de custos",
    result2: "99.9% disponibilidade",
    result3: "45% melhoria performance"
  },
  {
    id: 2,
    category: "cat2",
    img: somarCase2,
    title: "Disaster Recovery - Grupo Hospitalar",
    slug: "disaster-recovery-grupo-hospitalar",
    description: "Implementação de solução robusta de Disaster Recovery com RTO de 15 minutos e RPO zero para ambiente hospitalar crítico.",
    client: "Grupo Hospitalar Regional",
    service: "Disaster Recovery + Cloud",
    location: "Região Metropolitana, Brasil",
    result1: "15min RTO garantido",
    result2: "0% perda de dados",
    result3: "24/7 monitoramento"
  },
  {
    id: 3,
    category: "cat3",
    img: somarCase3,
    title: "Datacenter Virtual - Empresa de Logística",
    slug: "datacenter-virtual-empresa-logistica",
    description: "Implementação de datacenter virtual com auto-scaling, aumentando capacidade em 200% e reduzindo provisionamento em 60%.",
    client: "Empresa de Logística Nacional",
    service: "Datacenter Virtual + Auto-scaling",
    location: "Nacional, Brasil",
    result1: "200% aumento capacidade",
    result2: "60% redução provisionamento",
    result3: "85% economia licenciamento"
  },
  {
    id: 4,
    category: "cat4",
    img: somarCase4,
    title: "VDI Windows 11 - Escritório de Advocacia",
    slug: "vdi-windows-11-escritorio-advocacia",
    description: "Implementação de VDI Windows 11 para 300 usuários simultâneos, garantindo mobilidade e compliance jurídico.",
    client: "Escritório de Advocacia Nacional",
    service: "VDI Windows 11 + Segurança",
    location: "Nacional, Brasil",
    result1: "300 usuários simultâneos",
    result2: "95% redução chamados",
    result3: "40% economia hardware"
  },
];
export default caseStudies;